import React, { useState } from 'react'

export default function QA() {
    const accordionData = [
        {
            title: 'What is NIFTY Marketplace?',
            content: 'We are a leading NFT marketplace designed to bridge the gap between exceptional digital artists and their fans, as well as collectors of unique tokens.'
        },
        {
            title: 'What can I find on the platform?',
            content: 'Explore a diverse range of NFTs, from digital art and collectibles to music, gaming assets, and beyond. Our platform features work from both emerging and established artists.'
        },
        {
            title: 'Is the platform beginner-friendly?',
            content: 'Absolutely! Our user-friendly interface makes it easy for anyone, regardless of experience, to explore and trade NFTs.'
        },
        {
            title: 'Do I need cryptocurrency to use the platform?',
            content: "No, you don't need cryptocurrency to use NIFTY. It's the most accessible NFT marketplace, allowing anyone to buy NFTs with a bank card. No need to understand cryptocurrency — just a few clicks and you can own your first NFT today."
        },
    ]
    const [activeIndex, setActiveIndex] = useState(0);

    const toggleAccordion = (index) => {
        if (activeIndex === index) {
            setActiveIndex(0);
        } else {
            setActiveIndex(index);
        }
    }
    return (
        <div className="container md:mt-24 mt-16">
            <div className="grid grid-cols-1 text-center">
                <h3 className="mb-4 md:text-3xl text-2xl md:leading-snug leading-snug font-semibold">Q&A</h3>
            </div>

            <div className="flex justify-center mt-10">
                <div className="lg:w-2/3">
                    <div id="accordion-collapseone" data-accordion="collapse" className="mt-6">
                        {accordionData.map((item, index) => (
                            <div key={index} className="relative shadow dark:shadow-gray-800 rounded-md overflow-hidden mt-4">
                                <h2 className="text-base font-semibold" id="accordion-collapse-heading-1">
                                    <button onClick={() => toggleAccordion(index)} type="button"
                                        className={`flex justify-between items-center p-5 w-full font-semibold text-start ${activeIndex === index ? 'bg-gray-50 dark:bg-slate-800 text-violet-600' : ''}`}
                                        data-accordion-target="#accordion-collapse-body-1" aria-expanded="true" aria-controls="accordion-collapse-body-1">
                                        <span>{item.title}</span>
                                        <svg data-accordion-icon className={`size-4  shrink-0 ${activeIndex === index ? "rotate-180" : "rotate-360"}`} fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                            <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd"></path>
                                        </svg>
                                    </button>
                                </h2>
                                {activeIndex === index && (
                                    <div id="accordion-collapse-body-1" aria-labelledby="accordion-collapse-heading-1">
                                        <div className="p-5">
                                            <p className="text-slate-400 dark:text-gray-400">{item.content}</p>
                                        </div>
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}
